export default "__VITE_ASSET__db747b6a__"